import { useEffect, useRef, useState } from "react";

// "Resend code" control with a cooldown. Starts counting down on mount (a code was just sent).
export const ResendCode = ({ onResend, seconds = 30, testid = "resend-code", onSent }) => {
  const [left, setLeft] = useState(seconds);
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);

  const start = () => {
    setLeft(seconds);
    clearInterval(timer.current);
    timer.current = setInterval(() => {
      setLeft((s) => {
        if (s <= 1) {
          clearInterval(timer.current);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    start();
    return () => clearInterval(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const click = async () => {
    setBusy(true);
    try {
      await onResend();
      start();
      onSent?.();
    } catch (e) {
      /* surfaced by parent if needed */
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testid}
      disabled={left > 0 || busy}
      onClick={click}
      className="text-xs font-medium text-brand hover:underline disabled:text-slate-400 disabled:no-underline"
    >
      {busy ? "Sending…" : left > 0 ? `Resend code in ${left}s` : "Resend code"}
    </button>
  );
};
